/* pages.js — URL helpers. The word-based page matching that lived here (token index +
   slug/path scoring) was replaced by the semantic engine on 2026-08-26; see semantic.js. */

export const pathOf = url => { try { return String(url).startsWith("http") ? new URL(url).pathname : String(url); } catch (e) { return String(url); } };
